<template>
	<div class="chat-body" id="scroller" :style="cssVars">
		<InitialMessageBot />
		<div class="message-bubble" v-for="link in links" :key="link.id">
			<a :href="link.url" target="_blank">
				<v-btn class="button-rounding" block>{{ link.description }}</v-btn>
			</a>
		</div>
		<CheckEmail v-if="status === 'check-email'" />
		<div
			v-if="status == 'check-email'"
			class="d-flex flex-column max-width-important"
		>
			<div
				v-for="(msg, index) in messages"
				:key="index"
				:class="{
					'align-self-start': msg.author === 'bot',
					'align-self-end': msg.author === 'user',
					'message-container': true,
				}"
			>
				<BotMessage v-if="msg.author == 'bot'" :data="msg" />
				<UserMessage v-if="msg.author == 'user'" :data="msg" />
			</div>
		</div>
		<Catalogue v-if="status == 'catalogue'" />
		<Products v-if="status == 'products'" />
		<ProductDetails v-if="status == 'product'" />
		<Extras v-if="status == 'extras'" />
		<Faqs v-if="status == 'faqs'" />
		<Cart v-if="status == 'cart' || status == 'choose-delivery'" />
		<ChooseDelivery
			v-if="status == 'choose-delivery' || status === 'get-address'"
		/>
		<ClientAddressGetterMap v-if="status == 'get-address'" />
		<div
			v-if="status == 'get-address'"
			class="d-flex flex-column max-width-important"
		>
			<div
				v-for="(msg, index) in address_messages"
				:key="index"
				:class="{
					'align-self-start': msg.author === 'bot',
					'align-self-end': msg.author === 'user',
					'message-container': true,
				}"
			>
				<BotMessage v-if="msg.author == 'bot'" :data="msg" />
				<UserMessage v-if="msg.author == 'user'" :data="msg" />
			</div>
		</div>
		<Banks v-if="status == 'banks'" />
		<Bill v-if="status == 'bill' || status == 'payment'" />
		<div
			v-if="status == 'payment'"
			class="d-flex flex-column max-width-important"
		>
			<div
				v-for="(msg, index) in payment_messages"
				:key="index"
				:class="{
					'align-self-start': msg.author === 'bot',
					'align-self-end': msg.author === 'user',
					'message-container': true,
				}"
			>
				<BotMessage v-if="msg.author == 'bot'" :data="msg" />
				<UserMessage v-if="msg.author == 'user'" :data="msg" />
			</div>
		</div>
		<WebPush />
		<span style="opacity: 0">{{ updater }}</span>
	</div>
</template>
<script>
import InitialMessageBot from "./bot/InitialMessage";
import CheckEmail from "./bot/CheckEmail";
import Catalogue from "./bot/Catalogue";
import Products from "./bot/Products";
import ProductDetails from "./bot/ProductDetails";
import Extras from "./bot/Extras";
import Faqs from "./bot/faqs";
import Cart from "./bot/Cart";
import Banks from "./bot/banks";
import Bill from "./bot/bill";
import UserMessage from "./user/message";
import BotMessage from "./bot/generic_bot_message";
import ChooseDelivery from "./bot/ChooseDelivery";
import ClientAddressGetterMap from "../Map/ClientAddressGetterMap";
import WebPush from '../WebPush.vue';

export default {
	components: {
		WebPush,
		InitialMessageBot,
		Catalogue,
		Products,
		ProductDetails,
		Extras,
		Faqs,
		Cart,
		ChooseDelivery,
		Banks,
		Bill,
		UserMessage,
		BotMessage,
		CheckEmail,
		ClientAddressGetterMap,
	},
	mounted() {
		this.$store.commit('chatStore/STATUS', "")
	},
	methods: {
		isValidUrl: (url) => {
			try {
				new URL(url);
			} catch (e) {
				console.error(`${url} is not a valid url`)
				return false;
			}
			return true;
		},
	},
	computed: {
		links() {
			if (this.store.links)
				return this.store.links.filter((link) => this.isValidUrl(link.url));
			return [];
		},
		cssVars() {
			return {
				"--bot-image": `url(${this.$store.getters["chatStore/get_structure"].image.url})`,
			};
		},
		overlay() {
			return this.$store.getters["chatStore/get_request"];
		},
		status() {
			return this.$store.getters["chatStore/get_status"];
		},
		messages() {
			return this.$store.getters["chatStore/get_messages"];
		},
		payment_messages() {
			return this.$store.getters["chatStore/get_payment_messages"];
		},
		address_messages() {
			return this.$store.getters["chatStore/get_address_messages"];
		},
		updater() {
			return this.$store.getters["chatStore/updater"];
		},
		store() {
			return this.$store.getters["chatStore/get_store_data"];
		},
		uploading() {
			return this.$store.getters["chatStore/get_uploading"].uploading;
		},
	},
	updated() {
		var myDiv = document.getElementById("scroller");
		myDiv.scrollTop = myDiv.scrollHeight;
	},
};
</script>
<style lang="scss">
.button-rounding {
	border-radius: 8px !important;
}
.chat-body {
	width: 100%;
	position: relative; // needed for extras snackbar position
}
/* Hide scrollbar for Chrome, Safari and Opera */
.chat-body::-webkit-scrollbar {
	display: none;
}
/* Hide scrollbar for IE, Edge and Firefox */
.chat-body {
	-ms-overflow-style: none; /* IE and Edge */
	scrollbar-width: none; /* Firefox */
	background-color: var(--chat-bg);
	backdrop-filter: blur(3px);
	-webkit-backdrop-filter: blur(3px);
}
.message-container {
	max-width: 70%;
}
@media (max-width: 600px) {
	.message-container {
		max-width: 95%;
	}
}
.max-width-important {
	width: 100% !important;
	max-width: 100% !important;
}
.message-bubble {
	background-color: var(--chat-bubble-color);
	padding: 10px;
	border-radius: 16px;
	max-width: 95%;
	min-width: 70%;
	width: auto;
	margin-bottom: 10px;
	margin-left: 11px;
	margin-right: 40px;
	img {
		border-radius: 12px;
	}
	a {
		text-decoration: none;
	}
	& > button,
	a > button,
	.app-button {
		background-color: var(--app-button) !important;
		color: var(--app-button-text) !important;
	}
	position: relative;
	.message-content > span {
		white-space: pre-line;
	}
}
// .message-bubble::before {
// 	position: absolute;
// 	right: auto;
// 	bottom: 0.6em;
// 	left: -12px;
// 	height: 0;
// 	content: "";
// 	border: 6px solid transparent;
// 	border-right-color: var(--primary-color);
// 	z-index: 2;
// }
// .message-bubble::after {
// 	content: "";
// 	background-image: var(--bot-image);
// 	background-size: cover;
// 	background-position: center center;
// 	background-repeat: no-repeat;
// 	position: absolute;
// 	border: 1px solid;
// 	right: 100%;
// 	bottom: -6px;
// 	flex-shrink: 0;
// 	flex-grow: 0;
// 	z-index: 1;
// 	height: 50px;
// 	width: 50px;
// 	border-radius: 25px;
// 	margin: 0 10px;
// }
@media (max-width: 400px) {
	// .message-bubble {
	// 	margin-left: 40px;
	// }
	.message-bubble::after {
		width: 30px;
		height: 30px;
		bottom: 1px;
	}
}
@media (max-width: 330px) {
	// .message-bubble {
	// 	margin-left: 10px;
	// }
	.message-bubble::after {
		width: 0;
		display: none;
	}
}
@media (max-width: 460px) {
	button {
		font-size: 0.8rem !important;
	}
}
@media (max-width: 360px) {
	button {
		font-size: 0.6rem !important;
	}
}
</style>
